import React, { useEffect, useState } from "react";
import "./FDCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

export default function FDCertificates() {
  const [form, setForm] = useState({
    receiptNo: "",
    date: "",
    receivedFrom: "",
    acNo: "",
    nomineeName: "",
    typesOfDeposit: "",
    age: "",
    relation: "",
  });
  const [company, setCompany] = useState(null);
  const [nomineeData, setNomineeData] = useState("");
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const generatePDF = async () => {
    const input1 = document.getElementById('page1');
    const input2 = document.getElementById('page2');
    const pdf = new jsPDF("p", "mm", "a4");
    // page 1

    const canvas1 = await html2canvas(input1, { scale: 2, useCORS: true, backgroundColor: "#ffffffff" });
    const imgData1 = canvas1.toDataURL('image/png');
    const imgWidth1 = 210;
    const pageHeight1 = 297;
    const imgHeight1 = (canvas1.height * imgWidth1) / canvas1.width;
    pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth1, imgHeight1);

    // page 2 
    pdf.addPage();
    const canvas2 = await html2canvas(input2, { scale: 2, useCORS: true, backgroundColor: "#ffffffff" });
    const imgData2 = canvas2.toDataURL('image/png');
    const imgWidth2 = 210;
    const pageHeight2 = 297;
    const imgHeight2 = (canvas2.height * imgWidth2) / canvas2.width;
    pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth2, imgHeight2);

    pdf.save("FD_Certificate.pdf");
  };


  // dynamic data........
  const { state } = useLocation();
  const currentFDRowData = state?.row;
  console.log("fd row data :", currentFDRowData)


  // Fetch Profile (runs once)
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);


  // Fetch Company and Nominee 
  useEffect(() => {
    const fetchAllData = async () => {
      if (!profile?.superAdminId) return;

      // Fetch Company
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const companyData = await res.json();

        if (res.ok) {
          // Fix logo URL
          if (companyData.logo) {
            companyData.logoUrl = `https://payyug.in/${companyData.logo.replace(
              /^images\//,
              ""
            )}`;
          }

          setCompany(companyData);
        } else {
          console.error("Company fetch failed:", companyData);
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }

    };

    fetchAllData();
  }, [profile?.superAdminId]);


  return (
    <div className="FDcertificates-containers">
      <div id="page1">
        <div className="FDcertificates-container">
          <div className="FDcertificates-box">
            <div className="FDheaders">
              <div className="FDlefts">
                <div className="FDlogos">
                  <img src={company?.logoUrl} alt="Logo" />
                </div>
                <div className="fd-company-details">
                  <h1 className="FDtitles">{company?.name || "SANPANNATA MUTUAL BENEFIT NIDHI LIMITED."}</h1>
                  <p className="FDsubtitles">CIN No. : {company?.cin || "U64199MH2023PLN405930"}</p>
                  <p className="FDsubtitles">
                    Reg. Office: {company?.address || "Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra"}
                  </p>
                </div>
                <div style={{ opacity: 0 }} className="FDlogos">
                  <img src={company?.logoUrl} alt="Logo" />
                </div>
              </div>
            </div>
            <div className="fd-header-container">
              <div className="fd-header-line"></div>

              <div className="fd-header-banner">
                <span className="fd-header-text-hindi">{currentFDRowData.accountType === "FD" ? "आवर्त जमा प्रमाणपत्र" : "एमआईएस प्रमाणपत्र"}</span>
                <span className="fd-header-separator">/</span>
                <span className="fd-header-text-english">{currentFDRowData.accountType === "FD" ? "Fixed Deposit Certificate" : "Mis Certificate"}</span>
              </div>

              <div className="fd-header-line"></div>

              <div className="fd-header-office-copy">Original</div>
            </div>



            <div className="FDinfos-section">
              <div className="FDlefts-info">
                <div className="FDfields">
                  <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData?.accountNumber || "N/A"}<br />(खाता सं.)</label>
                  {/* <input name="acNo" value={form.acNo}  /> */}
                </div>
                <div className="FDfields">
                  <label> Customer Id. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentFDRowData?.customer?.userId || "N/A"}<br />(ग्राहक आईडी)</label>
                  {/* <input name="receiptNo" value={form.receiptNo} /> */}
                </div>

                <div className="FDfields">
                  <label>Received From Shri/Smt. :-  &nbsp;{currentFDRowData?.customer?.fullName || "N/A"} <br /> (श्री/श्रीमती से प्राप्त) </label>
                  {/* <input name="receivedFrom" value={form.receivedFrom}  /> */}

                </div>

                <div className="FDfields">
                  <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData?.accountType === "MIS" ? `(${currentFDRowData?.accountType}) Account` : `${currentFDRowData?.accountType} Account` || "N/A"}<br />(जमा के प्रकार)</label>
                  {/* <input
                    name="typesOfDeposit"
                    value={form.typesOfDeposit}
                    
                  /> */}
                </div>
                <div className="FDfields">
                  <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{new Date(currentFDRowData?.openingDate).toLocaleDateString("en-IN") || "N/A"} <br />(दिनांक)</label>
                  {/* <input name="date" value={form.date}  /> */}
                </div>
              </div>

              <div className="FDrights-info">

                <div className="FDfields">
                  <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData?.nominee?.nomineeName || "N/A"}<br />(नामांकित व्यक्ति का नाम)</label>
                  {/* <input name="nomineeName" value={form.nomineeName} /> */}
                </div>
                <div className="FDfields">
                  <label>Nominee Dob &nbsp; :- &nbsp;&nbsp;&nbsp;{currentFDRowData?.nominee?.nomineeDob}<br />(नामांकित व्यक्ति की जन्मतिथि)</label>
                  {/* <input name="age" value={form.age}  /> */}
                </div>
                <div className="FDfields">
                  <label>Nominee Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{currentFDRowData?.nominee?.nomineeRelation}<br />(नामांकित व्यक्ति का संबंध)</label>
                  {/* <input name="relation" value={form.relation} /> */}
                </div>
                {
                  currentFDRowData.accountType === "MIS" && <>
                    <div className="FDfields">
                      <label>Monthly Interest &nbsp; :- &nbsp;&nbsp;&nbsp;{currentFDRowData?.monthlyInterest}<br />(मासिक ब्याज)</label>
                      {/* <input name="acNo" value={form.acNo}  /> */}
                    </div>
                  </>
                }
              </div>
            </div>


            <div className="FDCdeposit-table">
              <table>
                <thead>
                  <tr>
                    <th rowSpan="2">
                      Deposit Amount<br />In Rupees
                      <span className="FDhindi">रुपयों में जमा राशि</span>
                    </th>
                    {/* <th rowSpan="2">
                  Deposit Date<br />
                  <span className="hindi">जमा तिथि</span>
                </th> */}
                    <th colSpan="2" className="FDc-hindi">
                      Deposit Date <br />
                      <span className="">जमा तिथि</span>
                    </th>

                    <th rowSpan="2">
                      Rate of Int P. A.<br />
                      <span className="hindi">वार्षिक ब्याज दर</span>
                    </th>
                    <th rowSpan="2">
                      Duration<br />
                      <span className="hindi">अवधि</span>
                    </th>
                    {/* <th rowSpan="2">
                  Maturity Date<br />
                  <span className="hindi">परिपक्वता तारीख</span>
                </th> */}
                    <th rowSpan="2">
                      Maturity Amt.<br />
                      <span className="hindi">परिपक्वता राशि</span>
                    </th>
                    {
                      currentFDRowData.accountType === "MIS" && <>
                        <th rowSpan="2">
                          Monthly Interest<br />
                          <span className="hindi">मासिक ब्याज</span>
                        </th>
                      </>
                    }
                  </tr>
                  <tr>
                    <th>
                      Start Date<br />
                      <span className="hindi">प्रारंभ तारीख</span>
                    </th>
                    <th>
                      Maturity Date<br />
                      <span className="hindi">परिपक्वता तारीख</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{currentFDRowData.depositAmount || "--"}</td>
                    <td className="inner">{new Date(currentFDRowData.openingDate).toLocaleDateString("en-GB") || "--"}</td>
                    <td className="inner">{new Date(currentFDRowData.maturityDate).toLocaleDateString("en-GB") || ""}</td>
                    <td>{currentFDRowData.roi || "--"}%</td>
                    <td>{currentFDRowData.tenureMonths || "--"}</td>
                    <td>{currentFDRowData.maturityAmount || "--"}</td>
                    {
                      currentFDRowData.accountType === "MIS" && <>
                        <td>{currentFDRowData.monthlyInterest || "--"}</td>
                      </>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="FDfooter">
              <div><br /> Cashier / कैशियर</div>
              <div><br /> Br. Manager / शाखाप्रमुख</div>
              <div><br /> Chairman / अध्यक्ष</div>
            </div>
          </div>
        </div>


        <div className="divider"></div>
        {/* End of 1st Container */}

        {/* Start of 2nd  Container */}

        {/* <div className="FDcertificates-container">
          <div className="FDcertificates-box">
            <div className="FDheaders">
              <div className="FDlefts">
                <div className="FDlogos">
                  <img src={company?.logoUrl} alt="Logo" />
                </div>
                <div>
                  <h1 className="FDtitles">{company?.name || "SANPANNATA MUTUAL BENEFIT NIDHI LIMITED."}</h1>
                  <p className="FDsubtitles">CIN No. : {company?.cin || "U64199MH2023PLN405930"}</p>
                  <p className="FDsubtitles">
                    Reg. Office: {company?.address || "Reg. Office & H.O.: Flat No. 2, Bldg. No. 2B, Ground Floor, Shree Gokul CHS,Vrindavan Society, Near Vrindavan Bus Stop, Thane (W) - 400601, Maharashtra"}
                  </p>
                </div>
              </div></div>
            <div className="fd-header-container">
              <div className="fd-header-line"></div>

              <div className="fd-header-banner">
                <span className="fd-header-text-hindi">{currentFDRowData.accountType === "FD" ? "आवर्त जमा प्रमाणपत्र" : "एमआईएस प्रमाणपत्र"}</span>
                <span className="fd-header-separator">/</span>
                <span className="fd-header-text-english">{currentFDRowData.accountType === "FD" ? "Fixed Deposit Certificate" : "Mis Certificate"}</span>
              </div>

              <div className="fd-header-line"></div>

              <div className="fd-header-office-copy">Duplicate</div>
            </div>



            <div className="FDinfos-section">
              <div className="FDlefts-info">
                <div className="FDfields">
                  <label> A/C. No. &nbsp;&nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData?.accountNumber || "N/A"}<br />(खाता सं.)</label>
                 
                </div>
                <div className="FDfields">
                  <label> Customer Id. &nbsp;&nbsp;&nbsp;:-  &nbsp;&nbsp;&nbsp;{currentFDRowData?.customer?.userId || "N/A"}<br />(ग्राहक आईडी)</label>
                  
                </div>

                <div className="FDfields">
                  <label>Received From Shri/Smt. :-  &nbsp;{currentFDRowData?.customer?.fullName || "N/A"} <br /> (श्री/श्रीमती से प्राप्त) </label>
                 

                </div>

                <div className="FDfields">
                  <label>Types of Deposit   &nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData.accountType === "MIS" ? `(${currentFDRowData.accountType}) Account` : `${currentFDRowData.accountType} Account` || "N/A"}<br />(जमा के प्रकार)</label>
                
                </div>
                <div className="FDfields">
                  <label> Date &nbsp; :- &nbsp;&nbsp;&nbsp;{new Date(currentFDRowData.openingDate).toLocaleDateString("en-IN") || "N/A"} <br />(दिनांक)</label>
                  
                </div>
              </div>

              <div className="FDrights-info">

                <div className="FDfields">
                  <label>Nominee Name  &nbsp;&nbsp;:- &nbsp;&nbsp;&nbsp;{currentFDRowData.nominee.nomineeName || "N/A"}<br />(नामांकित व्यक्ति का नाम)</label>
                  
                </div>
                <div className="FDfields">
                  <label>Nominee Dob &nbsp; :- &nbsp;&nbsp;&nbsp;{currentFDRowData.nominee.nomineeDob}<br />(नामांकित व्यक्ति की जन्मतिथि)</label>
                  
                </div>
                <div className="FDfields">
                  <label>Nominee Relation &nbsp; :-&nbsp;&nbsp;&nbsp;{currentFDRowData.nominee.nomineeRelation}<br />(नामांकित व्यक्ति का संबंध)</label>
                 
                </div>
                {
                  currentFDRowData.accountType === "MIS" && <>
                    <div className="FDfields">
                      <label>Monthly Interest &nbsp; :- &nbsp;&nbsp;&nbsp;{currentFDRowData.monthlyInterest}<br />(मासिक ब्याज)</label>
                      
                    </div>
                  </>
                }
              </div>
            </div>


            <div className="FDCdeposit-table">
              <table>
                <thead>
                  <tr>
                    <th rowSpan="2">
                      Deposit Amount<br />In Rupees
                      <span className="FDhindi">रुपयों में जमा राशि</span>
                    </th>
                   
                    <th colSpan="2" className="FDc-hindi">
                      Deposit Date <br />
                      <span className="">जमा तिथि</span>
                    </th>

                    <th rowSpan="2">
                      Rate of Int P. A.<br />
                      <span className="hindi">वार्षिक ब्याज दर</span>
                    </th>
                    <th rowSpan="2">
                      Duration<br />
                      <span className="hindi">अवधि</span>
                    </th>
                   
                    <th rowSpan="2">
                      Maturity Amt.<br />
                      <span className="hindi">परिपक्वता राशि</span>
                    </th>
                    {
                      currentFDRowData.accountType === "MIS" && <>
                        <th rowSpan="2">
                          Monthly Interest<br />
                          <span className="hindi">मासिक ब्याज</span>
                        </th>
                      </>
                    }
                  </tr>
                  <tr>
                    <th>
                      Start Date<br />
                      <span className="hindi">प्रारंभ तारीख</span>
                    </th>
                    <th>
                      Maturity Date<br />
                      <span className="hindi">परिपक्वता तारीख</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{currentFDRowData.depositAmount || "--"}</td>
                    <td className="inner">{new Date(currentFDRowData.openingDate).toLocaleDateString("en-GB") || "--"}</td>
                    <td className="inner">{new Date(currentFDRowData.maturityDate).toLocaleDateString("en-GB") || ""}</td>
                    <td>{currentFDRowData.roi || "--"}%</td>
                    <td>{currentFDRowData.tenureMonths || "--"}</td>
                    <td>{currentFDRowData.maturityAmount || "--"}</td>
                    {
                      currentFDRowData.accountType === "MIS" && <>
                        <td>{currentFDRowData.monthlyInterest || "--"}</td>
                      </>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="FDfooter">
              <div><br /> Cashier / कैशियर</div>
              <div><br /> Br. Manager / शाखाप्रमुख</div>
              <div><br /> Chairman / अध्यक्ष</div>
            </div>
          </div>
        </div>  */}
      </div>
      {/* End of 2nd Container */}

      {/* start of 1st Notice */}
      <div className="FDdivider"></div>
      <div id="page2">
        <div className="FDCnotice-container">
          {/* --- Heading --- */}
          <div className="FDCspecial-notice-header">
            <span className="FDCenglish-heading">Special Notice / </span>
            <span className="FDCmarathi-heading">विशेष सुचना</span>
          </div>

          {/* --- Rules/Points Section --- */}
          <div className="FDCrules-section">
            {/* Point 1 */}
            <div className="FDleft1-info">
              <div className="FDCrule-item">
                <span className="FDCrule-number">1.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    The Deposit will be accepted/renewed in rounded multiples of Rs. 100/- The
                    amount’s excess of multiple of Rs. 100/- and/or fractions thereof will be refunded
                  </p>
                </div>
              </div>

              {/* Point 2 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">2.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Deposit receipt is not transferable by endorsement nor the amount of deposit is withdrawable in part/s However the depositor can avail loan facility against the security of deposit as per rules.
                  </p>
                </div>
              </div>

              {/* Point 3 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">3.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Receipt in favour of joint holders will be issued in the name of two or more persons
                    and be made payable to any one of them or to the survivor’s as per mandate.
                  </p>
                </div>
              </div>

              {/* Point 4 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">4.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Due date of deposit will be recorded on the receipt to enable the depositor either to
                    receive payment of the amount due or to arrange for renewal of the deposits on the
                    receive payment of the amount due or to arrange for renewal of the deposits on the
                    due date. No/further intimation will be given to depositor.

                  </p>
                </div>
              </div>
              {/* Point 5 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">5.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    The interstrate are subject to change from time to time.
                  </p>
                </div>
              </div>

            </div>

            {/* Point 6 */}
            <div className="FDright1-info">
              <div className="FDCrule-item">
                <span className="FDCrule-number">6.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    At the time of receiving the payment or renewal on due date of deposits the deposit
                    revenue stamp other than Co-Operative societies and Shareholders.
                    receipt must be returned duly signed & discharged by the depositors by affixing Rs1/-
                  </p>
                </div>
              </div>

              {/* Point 7 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">7.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    The Society shall have lien on all deposits and reserve to itself, the right to appropriate
                    it towards any liability of the depositors.
                  </p>
                </div>
              </div>

              {/* Point 8 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">8.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Encashment of FD. before
                    The date of maturity will be at descreation of the SMPNP and will be allowed at the
                    rate of interest prescribed as per directives of MCA.
                  </p>
                </div>
              </div>

              {/* Point 9 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">9.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Individual Depositor can nominate a person at his own choice who is competent to
                    contract Incase nominee is minor the depositor should appoint guardian.
                  </p>
                </div>
              </div>

              {/* Point 10 */}
              <div className="FDCrule-item">
                <span className="FDCrule-number">10.</span>
                <div className="FDCrule-text">
                  <p className="FDCenglish-text">
                    Renewal is available only on presentation of matured receiptwithin 14 day
                    the date of its maturity.
                  </p>
                </div>
              </div></div>

          </div>


          {/* --- Table Section --- */}
          <div className="FDCsdeposit-table">
            {/* <table>
              <thead>
                  <tr className ="FDcsub">PARTICULARS OF INTEREST AND RENEWALS</tr>
                <tr>
                  <th>
                  
                    <span className="FDCssub">Date of Renewal <br /> प्रति माह रु.</span>
                  </th>
                  
                  <th>
                    
                    <span className="FDCssub">Amount Renewed <br /> अवधि</span>
                  </th>
                  <th>
                  
                    <span className="FDCssub">Period <br /> व्याज दर</span>
                  </th>
                  <th>
                    
                    <span className="FDCssub">Due Date <br />नियत तारीख</span>
                  </th>
                  <th>
                  
                    <span className="FDCssub">Interest Paid/Payable<br /> परिपक्वता राशि</span>
                  </th>
                  <th>
                    <span className="FDCssub">Signature of Authorised Officials wih Seal<br /> परिपक्वता राशि</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><br /></td>
                  <td>   </td>
                  <td>   </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td><br /></td>
                  <td>   </td>
                  <td>   </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table> */}

            <table>
              <thead>
                {/* <tr className ="FDcsub" style={{whiteSpace:"nowrap"}}>PARTICULARS OF INTEREST AND RENEWALS</tr> */}
                <tr>
                  <th>
                    {/* Per Month Rs. <br /> */}
                    <span className="FDCssub">Deposit Amount <br /> In Rupees <br /> रुपयों में जमा राशि</span>
                  </th>

                  <th>
                    {/* Duration <br /> */}
                    <span className="FDCssub">Deposit Date <br /> जमा तिथि</span>
                  </th>
                  <th>
                    {/* Interest Rate <br /> */}
                    <span className="FDCssub">Rate of Int <br /> व्याज दर</span>
                  </th>
                  <th>
                    {/* Due Date <br /> */}
                    <span className="FDCssub">Duration <br />अवधि</span>
                  </th>
                  <th>
                    {/* Maturity Amt. <br /> */}
                    <span className="FDCssub">Maturity Amount<br /> परिपक्वता राशि</span>
                  </th>
                  <th>
                    {/* Maturity Amt. <br /> */}
                    <span className="FDCssub">Maturity Date<br /> परिपक्वता तारीख</span>
                  </th>
                  {
                    currentFDRowData.accountType === "MIS" && <>
                      <th>
                        {/* Maturity Amt. <br /> */}
                        <span className="FDCssub">Monthly Interest<br /> मासिक ब्याज</span>
                      </th>
                    </>
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{currentFDRowData.depositAmount || "--"}</td>
                  <td>{new Date(currentFDRowData.openingDate).toLocaleDateString("en-IN") || "--"}</td>
                  <td>{currentFDRowData.roi || "--"}%</td>
                  <td>{currentFDRowData.tenureMonths || "--"}</td>
                  <td>{currentFDRowData.maturityAmount || "--"}</td>
                  <td>{new Date(currentFDRowData.maturityDate).toLocaleDateString("en-GB") || "--"}</td>
                  {
                    currentFDRowData.accountType === "MIS" && <td>{currentFDRowData.monthlyInterest || "--"}</td>
                  }
                </tr>
                {/* <tr>
                  <td><br /></td>
                  <td>   </td>
                  <td>   </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr> */}
              </tbody>
            </table>
          </div>
          {/* --- Footer/Signature Section --- */}
          <div className="FDCsignature-section">
            <div className="FDCreceipt-confirmation">
              <p className="FDCenglish-text">
                Received the within mentioned Principal Amount and Interest due thereon in
              </p>
            </div>

            <div className="FDCreceipt-confirmation">
              <p className="FDCenglish-text">
                Cash/by transfer to ________________________  Lien noted for Overdraft A/c No. _____________________________
                Signature/s verified _________________________________________
              </p>
            </div>
            <div className="FDCsignatures">
              <div className="FDCenglish-text"><br /><h4>**Verified Officer**</h4></div>
              <div className="FDCmarathi-text"><h5>**Signature of Depositor’s**</h5></div>
            </div>
          </div>
        </div>
        <div className="FDC-headline">
          <h3 className="FDCfooter-heading">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Received Term Deposit Receipt on ____________________________  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Signature _______________________________   </h3> </div>

        {/* End  of 1st Notice */}

        {/* start of 1st Notice */}
        <div className="FDdivider"></div>
       
      </div>





      <button className="FDCpdf-button" onClick={generatePDF}>Download PDF</button>
    </div>

  );
}